module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_8003.afa6df01.png";